<template>
    <div class="search">
        <ais-index :index-name="indexName"
                   :search-store="searchStore"
                   :query-parameters="facet"
                   :auto-search="false"
                   :query="query">

            <form v-on:submit.prevent="submit">
                <i class="icon magglass"></i>
                <ais-input v-on:query="updateQuery" placeholder="Search Our Site.."></ais-input>
            </form>
            
            <div class="shadow" style="position: absolute; width: 100%; background-color: #fff;" v-show="query.length > 2">
                <ais-menu attribute="type" :sort-by="['name:asc']">
                    <div style="clear:both" slot="footer"></div>
                </ais-menu>

                <ais-results :results-per-page="10">
                    <template slot-scope="{ result }">
                        <div class="ais-result">
                            <a :href="baseUrl + result.url">
                                <div style="float: left; width: 19%; min-height: 1px">
                                    <img v-if="result.image" :src="result.image" width="100%">
                                </div>
                                <div style="float: left; width: 79%; margin-left: 2%">
                                    <p style="font-weight: bold">
                                        <ais-highlight :result="result" attribute-name="title"></ais-highlight>
                                    </p>
                                    <p>
                                        <span v-bind:class="[{ catalogue: result.type === 'Catalogue' }, { inventory: result.type === 'Inventory' }, 'label']">{{result.type}}</span>
                                        <span class="label search-store" v-show="result.search_label">{{result.search_label}}</span>
                                        <span class="label search-store" v-show="result.store_city">{{result.store_city}}</span>
                                        <span class="label search-price" v-show="result.price">${{parseFloat(result.price).toLocaleString('en-US')}}</span>
                                    </p>
                                    <p class="description nowrap overflow-ellipses">
                                        <ais-snippet :result="result" attribute-name="description"></ais-snippet>
                                    </p>
                                </div>
                                <div style="clear: both"></div>
                            </a>
                        </div>
                    </template>
                    <div class="text-center" slot="footer">
                        <a style="color: #fff !important;display: block; background: #a9161f; padding: 15px;" :href="viewAllLink">View All Results</a>
                    </div>
                </ais-results>

                <ais-no-results>
                    <template slot-scope="props">
                        <div class="ais-result">
                            <p>Couldn't find what you were looking for? <a href="/contact">Contact us</a> to find out more about <strong>{{ props.query }}</strong>.</p>
                            <p><a href="/inventory">View our inventory</a></p>
                        </div>
                    </template>
                </ais-no-results>
            </div>
            
        </ais-index>
    </div>
</template>

<script>
    import {createFromAlgoliaCredentials} from 'vue-instantsearch';

    const searchStore = createFromAlgoliaCredentials(window.algolia.app_id, window.algolia.search_key);
    export default {
        props: {
            price: {
                type: Number,
                default: 0
            }
        },
        data() {
            return {
                searchStore,
                facet: {
                    filters: '(regions:' + window.appVars.region + ')'
                },
                baseUrl: window.appVars.url,
                query: '',
                indexName: window.algolia.index_name,
            };
        },
        methods: {
            updateQuery(q) {
                this.query = q;
            },
            submit() {
                window.location = this.viewAllLink;
            }
        },
        computed: {
            viewAllLink() {
                return encodeURI('/search?q=' + this.query);
            },
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/SearchBar.vue